export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Vixgen'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

// The app's own root path (Vite `base`): '/video/' in production, '/' in dev.
// Use this for full-page navigations back to the app root — navigating to a bare
// '/' leaves the app's base path and, behind the shared apps.wrks.ai host, gets
// redirected to another service (e.g. /image).
export const APP_BASE_PATH = import.meta.env.BASE_URL

// Wrks portal of each account source; `/api/config` loginUrl names this deployment's.
export const WRKS_PORTAL_URLS = { gov: 'https://gov.wrks.ai/', wrks: 'https://wrks.ai/' } as const

// The image app (pixgen) of this deployment. It shares the host (apps.wrks.ai or
// gov-apps.wrks.ai) under /image/, so a root-relative link keeps gov users on the gov
// deployment; an absolute apps.wrks.ai link sent them to the AWS app.
export const IMAGE_APP_URL = '/image/'

export type VideoRatio = '16:9' | '9:16' | '1:1' | '4:3' | '3:4' | '21:9'

// 라벨은 i18n 키로 관리한다 (값은 locales/*.json 의 aspectRatios.*)
export const VIDEO_RATIO_OPTIONS = [
  { id: '16:9' as const, labelKey: 'aspectRatios.16:9' },
  { id: '9:16' as const, labelKey: 'aspectRatios.9:16' },
  { id: '1:1' as const, labelKey: 'aspectRatios.1:1' },
  { id: '4:3' as const, labelKey: 'aspectRatios.4:3' },
  { id: '3:4' as const, labelKey: 'aspectRatios.3:4' },
  { id: '21:9' as const, labelKey: 'aspectRatios.21:9' },
] as const

export type VideoResolution = '768P' | '2K'

// Resolution labels are provider-defined and language-neutral.
export const VIDEO_RESOLUTION_OPTIONS = [
  { id: '768P' as const, label: '768P', descriptionKey: 'resolutions.768P' },
  { id: '2K' as const, label: '2K', descriptionKey: 'resolutions.2K' },
] as const
